import firebase from '@/firebase'
import { FS_COLLECTIONS } from '@/firebase'
import { update } from 'autosize'
const db = firebase.firestore()

const obtenerCantidadPorProductoEnServicioCaso = (id_producto, id_almacen, getters) => {

  const almacen = getters.almacenes[id_almacen]
  if (!almacen) return 0

  const productos = almacen.productos__idx
  if (!productos) return 0

  const cantidad = productos[id_producto]
  if (!cantidad) return 0

  return cantidad

}

const obtenerCantidadPorTraspaso = (id_producto, id_almacen, getters) => {

  const almacen = getters.almacenes[id_almacen]
  if (!almacen) return {}

  const traspasos = almacen.traspasos__idx
  if(!traspasos) return {}

  const traspaso = traspasos[id_producto]
  if(!traspaso) return {}

  return traspaso

}

const obtenerCantidadManualAgregada = (id_producto, id_almacen, almacenes) => {

  const almacen = almacenes[id_almacen]
  //console.log("🚀 ~ obtenerCantidadManualAgregada ~ almacen:", almacen)
  if (!almacen) return 0

  const cantidades_productos = almacen.cantidadesV2 || almacen.cantidades_productos
  if(!cantidades_productos) return 0

  const producto = cantidades_productos[id_producto]
  if(!producto) return 0

  const cantidad = producto.cantidad_manual
  if(!cantidad) return 0

  return cantidad

}

const obtenerResumenProducto = (producto, id_producto, almacenes) => {
  const item = {}
  item.resumenAlmacenes = {}
  item.producto = producto.nombre
  item.id_producto = id_producto

  for (const id_almacen in almacenes) {

    item[id_almacen] = 0

    item.resumenAlmacenes[id_almacen] = {
      cantidad: 0,
      cantidad_real: 0,
    }



    //ESTO SE DEBE ELIMINAR o COMENTAR
    // const compras = getters.indiceCompras.filter(e => e.id_almacen === id_almacen)

    // for (const j in compras) {

    //   const compra = compras[j]
    //   const conteoProducto = compra.productos[id_producto]
    //   if (conteoProducto) {
    //     item[id_almacen] += conteoProducto
    //     item.resumenAlmacenes[id_almacen].cantidad += conteoProducto
    //     item.resumenAlmacenes[id_almacen].cantidad_real += conteoProducto
    //   }
      

    // }

    //Esto es para descontar cada que se compra un producto desde serviciocasos
    // const cantidadEnAlmacenPorServicioCaso = obtenerCantidadPorProductoEnServicioCaso(
    //   id_producto, id_almacen, getters
    // )
    // item[id_almacen] -= cantidadEnAlmacenPorServicioCaso
    // item.resumenAlmacenes[id_almacen].cantidad -= cantidadEnAlmacenPorServicioCaso


    //Aumentamos la cantidad manual asignada desde inventarios si existe
    const cantidadManualAgregada = obtenerCantidadManualAgregada(id_producto, id_almacen, almacenes)
    item[id_almacen] += cantidadManualAgregada
    item.resumenAlmacenes[id_almacen].cantidad += cantidadManualAgregada
    //console.log("cantidad de resumen almacenes",item.resumenAlmacenes[id_almacen].cantidad )
    //console.log("cantidad de almacen",item[id_almacen])
    //Validamos si hay traspaso ente almacenes
    // const traspaso = obtenerCantidadPorTraspaso(id_producto, id_almacen, getters)
    
    // if(Object.keys(traspaso).length){

    //   console.log("Traspaso ", traspaso)

    //   item[id_almacen]+= parseInt(traspaso.cantidad_recibida)
    //   item.resumenAlmacenes[id_almacen].cantidad += parseInt(traspaso.cantidad_recibida)

    //   item[id_almacen]-= traspaso.cantidad_enviada
    //   item.resumenAlmacenes[id_almacen].cantidad -= traspaso.cantidad_enviada


    // }

  }

  return item
}

const store = {
  getters: {
    indiceInventarios: (state, getters) => {

      const lista = []
      const productos = getters.productosLista
      const servicios = getters.serviciosLista
      const almacenes = getters.almacenes
      if(!Object.keys(productos).length || !Object.keys(servicios).length || !Object.keys(almacenes).length){
        return [];
      }
      //console.log("🚀 ~ file: index.js:128 ~ productos:", productos)
      //console.log("🚀 ~ file: index.js:131 ~ servicios:", servicios)
      //console.log("🚀 ~ file: index.js:131 ~ almacenes:", JSON.stringify(almacenes))

      const listaProServ = {...productos, ...servicios};
      //console.log("🚀 ~ file: index.js:134 ~ listaProServ:", listaProServ)


      const listaIdServiciosPermititidos = [
        "b4734zd5-48c0-4801-8d16", //Desparasitación
        "b4734zd5-48c0-4801-8d15", //vacunacion
        "b4734zd5-48c0-4801-8d22", //Placas
      ]
      for (const id_producto in listaProServ) {

        const producto = listaProServ[id_producto]
        //console.log("🚀 ~ file: index.js:142 ~ producto:", producto)

        if(!producto){
          continue;
        }
        if(producto.extras){
          if (!listaIdServiciosPermititidos.includes(producto.servicio_padre)) {
            continue;
          }
        }
        
        if (producto.activo) {

          const item = obtenerResumenProducto(
            producto, id_producto, almacenes,
          )

          lista.push(item)

        }

      }

      //console.log("Lista ", lista)

      
      return lista.sort((a, b) => a.producto.localeCompare(b.producto))
      
    }
  },
  mutations: {
  },
  actions: {

  }
}

export default store



// WEBPACK FOOTER //
// ./src/store/inventarios/index.js